<script>
import { mapState, mapActions } from 'pinia';

import { useUserStore } from '../../../store/useUserStore.js';
import { getMyOfficials } from '../api/lobbying';

export default {
  name: 'CpRepresentivesToSelect',
  components: {
    VueSimpleSpinner: require('../vue-simple-spinner').default,
    handleImageError: require('../mixins/utils').default,
  },
  directives: {
    margin: require('../directives/margins').margin,
    marginTop: require('../directives/margins').marginTop,
    marginRight: require('../directives/margins').marginRight,
    marginBottom: require('../directives/margins').marginBottom,
    marginLeft: require('../directives/margins').marginLeft,
  },
  props: {
    handleDialog: Function,
  },
  mounted() {
    this.handleMyRepresentatives();
  },
  data() {
    return {
      representatives: [],
      loading: false,
      selectedRepresentativeId: null,
    };
  },
  computed: {
    ...mapState(useUserStore, ['isUserLogin', 'userProfileData']),
  },
  methods: {
    async handleMyRepresentatives() {
      this.loading = true;
      try {
        const response = await getMyOfficials();
        this.representatives = response.officials;
      } catch (error) {
        console.error('Error fetching my representatives:', error);
      } finally {
        this.loading = false;
      }
    },
    selectRepresentative(representativeId) {
      this.selectedRepresentativeId = representativeId;
      const representative = this.representatives.find(rep => rep.id === representativeId);
      this.$emit('representative-selected', representativeId, representative);
    },
    ...mapActions(useUserStore, ['getUserProfile']),
  },
};
</script>

<template>
  <div class="representativesToSelectContainer">
    <div v-if="loading" class="spinner">
      <vue-simple-spinner />
    </div>
    <div v-else class="representativesContainer">
      <i class="fal fa-landmark fa-3x primary-color"></i>
      <h3 class="headline black-color text-center">Contact Your Representatives</h3>
      <h4 class="subheadline1 neutral5-color text-center" v-margin-top="0">Select Who You Want to Contact</h4>
      <div class="representativesList">
        <div 
          v-for="rep in representatives" 
          :key="rep.id" 
          class="representativeItem"
          :class="{ 'selected': selectedRepresentativeId === rep.id }"
          @click="selectRepresentative(rep.id)"
        >
          <span class="imageContainer">
            <img :src="`${rep.large_img}`" alt="Representative's image" @error="handleImageError" />
          </span>
          <p class="caption1 neutral6-color text-center" v-margin-bottom="0">
            {{ rep.name }}
          </p>
          <p class="caption1 neutral6-color text-center" v-margin-top="0">
            {{ rep.charge }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.representativesToSelectContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.representativesContainer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.spinner {
  display: flex;
  align-items: center;
  justify-content: center;
}
.representativesList {
  display: flex;
  align-items: center;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  width: 100%;
  max-width: 400px;
  padding: 10px 0;
}
.representativeItem {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 5px;
  border: 1px solid var(--neutral3);
  border-radius: 0 0 8px 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
}
.representativeItem:hover {
  border-color: var(--primary-color);
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
.representativeItem.selected {
  border-color: var(--primary-color);
  background-color: var(--primary-blue-50);
}
.imageContainer {
  width: 120px;
  height: 100px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
.imageContainer img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
@media (max-width: 768px) {
  .representativesList {
    max-width: 300px;
  }
}
</style>
